module.exports = __webpack_public_path__ + "assets/htu-3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-3.jpg
// module id = 1190
// module chunks = 7